<template>
  <v-dialog :value="open" max-width="560" persistent scrollable>
    <v-card>
      <v-card-title class="headline">
        {{ $t('producto.modals.edicionMasivaAtributos.title') }}
      </v-card-title>
      <v-card-text>
        <p class="subtitle-2 mb-3">
          {{ $t('producto.modals.edicionMasivaAtributos.productosSeleccionados') }}:
          <strong>{{ selectedProductos.length }}</strong>
        </p>

        <v-row>
          <v-col cols="12">
            <marca-combobox
              v-model="marca"
              :is-required="false"
              :hide-details="false"
            />
          </v-col>
          <v-col cols="12">
            <modelo-combobox
              v-model="modelo"
              :marca="marca"
              :is-required="false"
              :hide-details="false"
            />
          </v-col>
          <v-col cols="12">
            <tamanio-combobox
              v-model="tamanio"
              :is-required="false"
              :hide-details="false"
            />
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="otrasCaracteristicas"
              :label="$t('producto.labels.otrasCaracteristicas')"
              :hint="$t('producto.modals.edicionMasivaAtributos.otrasHint')"
              prepend-icon="notes"
              color="secondary"
              outlined
              dense
              persistent-hint
              hide-details="auto"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="close">
          {{ $t('common.cancel') }}
        </v-btn>
        <v-btn
          color="primary"
          :disabled="!canSubmit || loading"
          :loading="loading"
          @click="confirm"
        >
          {{ $t('common.confirm') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ProductoProvider from "../../../providers/ProductoProvider";
import MarcaCombobox from "../ProductoForm/MarcaCombobox.vue";
import ModeloCombobox from "../ProductoForm/ModeloCombobox.vue";
import TamanioCombobox from "../ProductoForm/TamanioCombobox.vue";

export default {
  name: "ProductoEdicionMasivaAtributosModal",
  components: {
    MarcaCombobox,
    ModeloCombobox,
    TamanioCombobox,
  },
  props: {
    open: { type: Boolean, default: false },
    selectedProductos: { type: Array, default: () => [] },
  },
  data() {
    return {
      loading: false,
      marca: null,
      modelo: null,
      tamanio: null,
      otrasCaracteristicas: "",
    };
  },
  computed: {
    canSubmit() {
      if (!this.selectedProductos || this.selectedProductos.length === 0) return false;
      const hasMarca = this.marca && this.marca.id;
      const hasModelo = this.modelo && this.modelo.id;
      const hasTamanio = this.tamanio && this.tamanio.id;
      const hasOtras = String(this.otrasCaracteristicas || "").trim() !== "";
      return !!(hasMarca || hasModelo || hasTamanio || hasOtras);
    },
  },
  watch: {
    open(val) {
      if (val) this.resetForm();
    },
    marca() {
      this.modelo = null;
    },
  },
  methods: {
    resetForm() {
      this.marca = null;
      this.modelo = null;
      this.tamanio = null;
      this.otrasCaracteristicas = "";
      this.loading = false;
    },
    close() {
      this.$emit("close");
    },
    toMarcaInput(obj) {
      if (!obj || !obj.id) return null;
      return { id: String(obj.id), nombre: obj.nombre != null ? obj.nombre : null };
    },
    toModeloInput(obj) {
      if (!obj || !obj.id) return null;
      const out = {
        id: String(obj.id),
        nombre: obj.nombre != null ? obj.nombre : null,
      };
      if (obj.marca && obj.marca.id) {
        out.marca = {
          id: String(obj.marca.id),
          nombre: obj.marca.nombre != null ? obj.marca.nombre : null,
        };
      } else if (this.marca && this.marca.id) {
        out.marca = this.toMarcaInput(this.marca);
      }
      return out;
    },
    toTamanioInput(obj) {
      if (!obj || !obj.id) return null;
      return {
        id: String(obj.id),
        tamanio: obj.tamanio != null ? obj.tamanio : null,
      };
    },
    buildInput() {
      const input = {};
      const marcaIn = this.toMarcaInput(this.marca);
      if (marcaIn) input.marca = marcaIn;
      const modeloIn = this.toModeloInput(this.modelo);
      if (modeloIn) input.modelo = modeloIn;
      const tamanioIn = this.toTamanioInput(this.tamanio);
      if (tamanioIn) input.tamanio = tamanioIn;
      const otrasTrim = String(this.otrasCaracteristicas || "").trim();
      if (otrasTrim !== "") {
        input.modificarOtrasCaracteristicas = true;
        input.otrasCaracteristicas = otrasTrim;
      }
      return input;
    },
    async confirm() {
      if (!this.canSubmit) return;
      this.loading = true;
      try {
        const ids = this.selectedProductos.map((p) => String(p.id || p._id));
        const input = this.buildInput();
        const response = await ProductoProvider.productoUpdateManyAtributos(ids, input);
        const result = response && response.data && response.data.productoUpdateManyAtributos;
        if (result && result.productosActualizados > 0) {
          this.$emit("success", result.mensaje || this.$t("producto.modals.edicionMasivaAtributos.success"));
          this.close();
        } else {
          this.$emit(
            "error",
            (result && result.mensaje) || this.$t("producto.modals.edicionMasivaAtributos.error")
          );
        }
      } catch (err) {
        const msg =
          (err.graphQLErrors && err.graphQLErrors[0] && err.graphQLErrors[0].message) ||
          err.message ||
          this.$t("producto.modals.edicionMasivaAtributos.error");
        this.$emit("error", msg);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
